import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import UnitDetail from './components/UnitDetail.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageUnit',
  components: {
    UnitDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;